import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuth } from '../../../auth/AuthProvider';
import type { CreateMachineInput } from '../types/machine';
import { createMachine, selectMachine } from './machines.api';

export function useCreateMachine() {
  const auth = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ input, idempotencyKey }: { input: CreateMachineInput; idempotencyKey: string }) =>
      createMachine(input, idempotencyKey),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['machines', auth.activeCustomerId] });
    },
  });
}

export function useSelectMachine() {
  const auth = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (machineId: string) => selectMachine(machineId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['machines', auth.activeCustomerId] });
    },
  });
}
